<!-- 企业级-业务领域-仓储业务-预约管理 -->
<template>
  <div class="mainArea CBookManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索框 -->
        <div class="searchBox">
          <el-input class="w200" placeholder="请输入预约单号" v-model="keyword.number" clearable @keyup.enter.native="BookList(1)"></el-input>
          <el-input class="w200" placeholder="请输入制单人姓名" v-model="keyword.name" clearable @keyup.enter.native="BookList(1)"></el-input>
          <!-- <el-select v-model="keyword.type" placeholder="请选择预约类型" clearable @change="BookList(1)">
            <el-option label="预约入库" value="1"></el-option>
            <el-option label="预约出库" value="2"></el-option>
          </el-select> -->
          <!-- <el-date-picker
            v-model="keyword.time"
            type="daterange"
            range-separator="至"
            start-placeholder="制单开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="BookList(1)">
          </el-date-picker> -->
          <el-select v-model="keyword.status" placeholder="请选择状态" clearable @change="BookList(1)">
            <el-option label="待审核" value="0"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核未通过" value="2"></el-option>
          </el-select>
          <el-button class="searchBtn" type="primary" @click="BookList(1)">搜 索</el-button>
        </div>
        <!-- 添加预约信息 -->
        <div class="addButton">
          <el-button type="primary" @click="toAddBook">添加</el-button>
          <!-- <el-button type="primary">导入</el-button> -->
        </div>

        <el-table v-loading="loading" :data="bookData" style="width: 100%">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="订单号" prop="Id"></el-table-column>
          <el-table-column label="预约类型">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.Type == '1'">预约入库</span> -->
              <span>预约出库</span>
            </template>
          </el-table-column>
          <el-table-column label="制单人" prop="Creator"></el-table-column>
          <el-table-column label="制单时间" prop="CreatedTime"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span class="status1" v-if="scope.row.Status == '0'">待审核</span>
              <span class="status2" v-else-if="scope.row.Status == '1'">审核通过</span>
              <span class="status3" v-else>审核未通过</span>
            </template>
          </el-table-column>
          <el-table-column label="审核人" prop="Examine"></el-table-column>
          <el-table-column label="审核时间" prop="ExamineTime"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text"  v-if="scope.row.Status == '1'">查看</el-button>
              <el-popover
                placement="left"
                width="400"
                trigger="click" v-else>
                <el-select v-model="dioform.examineType" @change="examineChange($event,scope.row.Id)">
                  <el-option label="通过" value="1"></el-option>
                  <el-option label="不通过" value="2"></el-option>
                </el-select>
                <el-button slot="reference" type="text">审核</el-button>
              </el-popover>
              <!-- <el-button type="text">打印</el-button> -->
              <!-- <el-button type="text" @click="openDio('del',scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="paging" v-if="total>limits">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="limits"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>

      <el-dialog :title="dioTitle" :visible.sync="wareDio" width="500px" class="configDio wareDio" center>
        <div class="contDio">
          <el-form ref="form" :rules="rules" :model="dioform" label-width="90px">
            
            <el-form-item>
              <el-button type="primary" @click="submitWare('form')">确认</el-button>
              <el-button @click="wareDio = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"
  import { bussinessApi } from '../../../../../static/js/api'
  var vm
  export default {
    name: 'CBookManage',
    components: {
      CBreadCrumb,
    },
    data() {
      return {
        //搜索
        keyword:{
          number:'',//预约单号
          name:'',//制单人姓名
          type:'',//预约类型
          time:[],//制单时间区间
          status:'',//状态
        },

        loading:false,
        bookData:[],//预约数据

        //分页
        curr:1,
        limits:10,
        total:0,

        wareDio:false,//弹窗
        dioTitle:'',//弹窗标题
        dioform:{
          examineType:'',//审核类型
          wareName:'',//仓库名称
          wareAddress:'',//仓库名称
        },

        rules:{
          wareName:[
            { required: true, message: '请输入仓库名称', trigger: 'blur' },
          ],
          wareAddress:[
            { required: true, message: '请输入仓库地址', trigger: 'blur' },
          ],
        },
      };
    },
    mounted(){

    },
    async created() {
      vm = this
      this.BookList()
    },
    methods: {
      //打开弹窗
      openDio(type,info){
        if(type != 'del'){

        }else{
          this.$confirm('确定删除该订单？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            vm.UpdateBook(type,info.Id)
          }).catch(() => {});
        }
      },
      //审核改变
      examineChange(val,id){
        this.UpdateBook('edit', id, val)
      },
      //更改状态、删除
      async UpdateBook(type,id,status){
        let data = {
          'OrderId':id,
        }
        if(type == 'edit'){
          data.Status = status
        }
        const res = await bussinessApi.UpdateBook(data)
        if(res.ErrCode == 0){
          showToast('操作成功')
          vm.BookList(1)
        }else{
          showToast(res.ErrMsg)
        }
      },
      //跳转到添加预约单
      toAddBook(){
        var navBarActive = [{function_tab: 'CAddBook', function_name: '添加预约单'}]
        // 更新面包屑内容
        updataBreadCrumb(4, navBarActive)
        this.$router.push({
          path:'/CAddBook'
        })
      },

      //弹窗确认
      submitWare(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            
          } else {
            return false;
          }
        });
      },

      //获取预约列表
      async BookList(curr,limits){
        let data = {
          'OrderId': vm.keyword.number,
          'BookType': vm.keyword.type,
          'StartTime': vm.keyword.time ? vm.keyword.time[0] : '',
          'EndTime': vm.keyword.time ? vm.keyword.time[1] : '',
          'Status': vm.keyword.status,
          'Curr': curr ? curr : vm.curr,
          'Limits': limits ? limits : vm.limits
        }
        vm.loading = true
        const res = await bussinessApi.BookList(data)
        vm.loading = false
        if(res.ErrCode == 0){
          vm.bookData = res.Result.list
          vm.curr = res.Result.Curr
          vm.total = res.Result.Total
        }
      },
      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
        this.BookList(val)
      },
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CBookManage{
  .w200{
    width: 200px;
  }
  .status1{
    color: #409EFF;
  }
  .status2{
    color: #67C23A;
  }
  .status3{
    color: #F56C6C;
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 300px;
    }
  }

  .addButton {
    margin-bottom: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/CBookManage/CBookManage.vue